<template>
    <tr>
      <td class="ta_c fst"><a :href="`kwtp://uscode=${item.kwSymbol}`">{{item.symbol}}</a></td>
      <td>{{item.kwName}}</td>
      <td class="ta_c">{{item.fqDate}}/{{item.fiscalFlag}}</td>
      <td class="ta_c">{{item.turnValue}}</td>
      <td class="ta_r">{{item.netIncome}}</td>
      <td class="ta_r">{{item.netIncome1yVal}}</td>
      <td class="ta_r">{{item.netIncomeChange}}</td>
    <template v-if="item.tvo !== null">
      <td class="ta_r">{{item.tvo.weekRate}}</td>
      <td class="ta_r">{{item.tvo.rate1m}}</td>
      <td class="ta_r lst">{{item.tvo.rate3m}}</td>
    </template>
    <template v-else>
      <td class="ta_r"> - </td>
      <td class="ta_r"> - </td>
      <td class="ta_r lst"> - </td>
    </template>
    </tr>
</template>

<script>
export default {
  props: {
    item: Object
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/kiwoom/usRecord/pc/Crecord_sub.vue